import React, { useState } from 'react';

import {
  Box,
  Paper,
  Typography
} from '@mui/material';

import {
  DateCalendar,
  LocalizationProvider
} from '@mui/x-date-pickers';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import dayjs from 'dayjs';

const panelSx = {
  borderRadius: '8px',
  border: '1px solid #D9D9D9',
  boxShadow: 'none',
  overflow: 'hidden',
  bgcolor: '#FFFFFF'
};

const CalendarPanel = () => {
  const [selectedDate, setSelectedDate] = useState(
    dayjs('2026-07-24')
  );

  return (
    <Paper sx={panelSx}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DateCalendar
          value={selectedDate}
          onChange={newValue => {
            setSelectedDate(newValue);
          }}
          sx={{
            width: '100%',
            maxHeight: 'none',

            '& .MuiPickersCalendarHeader-root': {
              px: 1.5,
              minHeight: 50,
              mt: 0,
              mb: 0,
              bgcolor: '#FAFAFA',
              borderBottom: '1px solid #E0E0E0'
            },

            '& .MuiPickersCalendarHeader-label': {
              fontSize: 14,
              fontWeight: 500,
              color: '#424242'
            },

            '& .MuiPickersArrowSwitcher-button': {
              width: 30,
              height: 30
            },

            '& .MuiDayCalendar-header': {
              mt: 1
            },

            '& .MuiDayCalendar-weekDayLabel': {
              fontSize: 13,
              fontWeight: 500,
              color: '#424242'
            },

            '& .MuiPickersDay-root': {
              width: 30,
              height: 30,
              fontSize: 13,
              color: '#424242',

              '&:hover': {
                bgcolor: '#F5F5F5'
              }
            },

            '& .MuiPickersDay-root.Mui-selected': {
              bgcolor: '#4F81C7',
              color: '#FFFFFF',

              '&:hover': {
                bgcolor: '#4F81C7'
              },

              '&:focus': {
                bgcolor: '#4F81C7'
              }
            },

            '& .MuiPickersDay-dayOutsideMonth': {
              color: '#BDBDBD'
            },

            '& .MuiDayCalendar-monthContainer': {
              minHeight: 245
            }
          }}
        />
      </LocalizationProvider>
    </Paper>
  );
};

export default CalendarPanel;